import Graphics = cc.Graphics;
import ShopLotteryNewGGLPrefab, {ShopHongPrizeEntity} from "./ShopLotteryNewGGLPrefab";
import O1HD from "../../../../../../engines/gameEngine";
import ShopNewGglItemNode from "./ShopNewGglItemNode";
import { GeneralKind } from "../../../../../define/GeneralKind";
import NormalGameManager from "../../../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShopNewGGLNode extends cc.Component {

    @property(cc.Node)
    sprSpecialMask : cc.Node = null;
    @property(cc.Node)
    sprSpecial : cc.Node = null;

    @property(cc.Node)
    shadowNode : cc.Node = null;
    @property(cc.Node)
    touchNode : cc.Node = null;
    @property(cc.Node)
    maskNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"item预制体"})
    newGGLItemPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property(ShopLotteryNewGGLPrefab)
    mParentScript : ShopLotteryNewGGLPrefab = null;

    //当前奖项
    currPrizeArray : number[] = [];
    //已经打开的奖项
    hasOpenArray : string[] = [];

    /** 是否已存在特殊生肖值 */
    private bExistsSpecial = false;
    private bUseSpecial = false;
    
    onLoad () {
        cc.macro.ENABLE_MULTI_TOUCH = true;
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchstart",this.touchStart.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchmove",this.touchMove.bind(this) );
        O1HD.on("ShopNewGGLNode.reset" , this.reset , this );
    }


    start () {
        this.reset();
    }

    refreshData(){
        this.specialDataDispose();
        for ( let i = 0 ; i < 11 ; i ++ ) {
            let newGglItemNode = cc.instantiate( this.newGGLItemPrefab );
            newGglItemNode.getComponent( ShopNewGglItemNode ).bindData( this , `c${i}` );
            this.contentNode.addChild( newGglItemNode );
        }
    }

    specialDataDispose() {
        let gameData = NormalGameManager._instance.getGameData();
        
        if (gameData.lottery888Count >= 1) {
            this.sprSpecial.active = true;
            this.bUseSpecial = false;
        } else {
            this.sprSpecial.active = false;
            this.bUseSpecial = true;
        }
    }

    touchStart(e:cc.Event.EventTouch){

    }

    touchMove(e:cc.Event.EventTouch){
        let circleLen = GeneralKind.ScratchTicketValue.EVERY_CIRCLE_ADJUST;
        if ( e.getTouches().length > 1 ) {
            //多点触控
            let point1Pos = e.getTouches()[0].getLocation();
            let point2Pos = e.getTouches()[1].getLocation();
            let delta0 = e.getTouches()[0].getPreviousLocation().sub( e.getTouches()[0].getLocation() );
            let delta1 = e.getTouches()[1].getPreviousLocation().sub( e.getTouches()[1].getLocation() );
            if ( Math.abs(delta0.y) > circleLen || Math.abs(delta1.y) > circleLen ) {
                let needAddY = Math.max(Math.abs(delta0.y), Math.abs(delta1.y));
                let needAddCount = Math.floor( needAddY / circleLen );
                let j = 1;
                for ( let i = 1 ; i <= needAddY ; i += circleLen ) {
                    let pointPos1Temp = point1Pos.add( delta0.div(needAddCount).mul( j ) );
                    let pointPos2Temp = point2Pos.add( delta0.div(needAddCount).mul( j ) );
                    this._addLine( 
                        this.maskNode.convertToNodeSpaceAR( pointPos1Temp ) 
                        , this.maskNode.convertToNodeSpaceAR( pointPos2Temp )
                    );
                    O1HD.emit("ShopNewGglItemNode.checkJudge" , pointPos1Temp , pointPos2Temp );
                    j ++;
                }
            }
            this._addLine( 
                this.maskNode.convertToNodeSpaceAR( point1Pos ) 
                , this.maskNode.convertToNodeSpaceAR( point2Pos )
            );
            O1HD.emit("ShopNewGglItemNode.checkJudge" , point1Pos ,point2Pos );
        }else{
            //单点操作
            let distance = Math.abs( Math.floor( e.getLocation().sub( e.getPreviousLocation() ).mag() ) );
            if ( distance > circleLen ) {
                //补点操作
                for ( let num = 0 ; num < distance ; num += circleLen ) {
                    let subLocation : cc.Vec2 = e.getLocation().sub( e.getPreviousLocation() );
                    let actualLocation = e.getPreviousLocation().add( subLocation.div( distance ).mul( num ) );
                    this._addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                    O1HD.emit("ShopNewGglItemNode.checkJudgeNode" , actualLocation );
                }
            }
            this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
            O1HD.emit("ShopNewGglItemNode.checkJudgeNode" , e.getLocation() );
        }
    }

    //效果渲染
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){

        let circleSize = GeneralKind.ScratchTicketValue.SINGLE_TOUCH_CIRCLE;
	    this.adjustSpecialCircle(pos);
        // @ts-ignore
        // this.maskNode.getComponent(cc.Mask)._graphics;
        this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, circleSize );
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }

    _addLine( pos1:cc.Vec2 , pos2 : cc.Vec2 ){
	    this.adjustSpecialLine(pos1, pos2);
        // @ts-ignore
        let graphics : cc.Graphics = this.maskNode.getComponent(cc.Mask)._graphics;
        graphics.lineWidth = 50;
        graphics.lineCap = Graphics.LineCap.ROUND;
        graphics.strokeColor = cc.color( 20,20,20 );
        graphics.moveTo( pos1.x , pos1.y );
        graphics.lineTo( pos2.x , pos2.y );
        graphics.stroke();
    }

    setSpecialAwardData() {
        let gameData = NormalGameManager._instance.getGameData();
        gameData.lottery888Count++;
        NormalGameManager._instance.writeGameData();

        this.contentNode.children.forEach((node, i)=> {
            let script = node.getComponent( ShopNewGglItemNode );
            script.setShowSpecialAward(true);
        });
    }

    adjustSpecialLine(pos1:cc.Vec2, pos2 : cc.Vec2) {
        if (!this.bUseSpecial) {
            return;
        }

        if (cc.Intersection.lineRect( pos1 , pos2 , this.shadowNode.getBoundingBox())) {
            this.bUseSpecial = false;
            this.sprSpecial.active = true;
            return;
        }
        if (cc.Intersection.lineRect( pos1 , pos2 , this.sprSpecialMask.getBoundingBox())) {
            this.bUseSpecial = false;
            // 全中
            this.setSpecialAwardData();
        }
    }

    adjustSpecialCircle(pos:cc.Vec2) {
        if (!this.bUseSpecial) {
            return;
        }
        let circleSize = GeneralKind.ScratchTicketValue.EVERY_CIRCLE_ADJUST + 1;
        let rect = cc.rect( pos.x - circleSize  , pos.y - circleSize , circleSize*2 , circleSize*2);
        if ( this.shadowNode.getBoundingBox().containsRect( rect )) {
            this.bUseSpecial = false;
            this.sprSpecial.active = true;
            return;
        }
        if ( this.sprSpecialMask.getBoundingBox().containsRect( rect )) {
            this.bUseSpecial = false;
            // 全中
            this.setSpecialAwardData();
        }
    }

    /**
     * 开奖
     */
    openPrize( hongDefine : ShopHongPrizeEntity , node : cc.Node ){
        if ( hongDefine.flag ) {
            O1HD.getManagers().soundMgr.playSound("gglAddCoins").then();
            O1HD.getServices().userSrv.setCoins( hongDefine.prize , true , node );
        }
        this.hasOpenArray.push( hongDefine.uniqueId );
    }

    setSpecialValue() {
        this.bExistsSpecial = true;
    }

    isExistsSpecial() {
        return this.bExistsSpecial;
    }

    reset(){
        O1HD.emit("ShopNewGglItemNode.remove" );
        this.hasOpenArray = [];
        this.currPrizeArray = [];
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.clear();
        this.maskNode.opacity = 255;
        this.maskNode.active = true;
        this.bExistsSpecial = false;
        this.refreshData();
    }

}
